import React from "react"
import ReactModal from "react-modal"
import CloseIcon from "../../../assets/icons/CloseIcon"
import ArrowLeftMobileModal from "../../../assets/icons/ArrowLeftMobileModal"
import { isMobile } from "react-device-detect"

import styles from "./index.module.scss"

ReactModal.setAppElement("#root")

const modalSizes = {
  "2xl": 1000,
  xlg: 800,
  lg: 700,
  md: 541,
  sm: 426,
}

const modalContentSizes = {
  "2xl": 900,
  xlg: 650,
  lg: 590,
  md: 461,
  sm: 378,
}

function Header(props) {
  const { children, onClose, bIconClose = true, className, ...rest } = props

  const fnHandleOnClose = (e) => {
    e?.preventDefault()
    e?.stopPropagation()
    onClose?.()
  }
  
  return (
    <>
      <div className={`${styles.modalHeader} ${className || ""}`} {...rest}>
        <div className={styles.closeMobile}>
          {bIconClose && (
            <ArrowLeftMobileModal
              onClick={fnHandleOnClose}
            />
          )}
        </div>
        <p>{children}</p>
        {bIconClose && (
          <CloseIcon
            className={styles.close}
            onClick={fnHandleOnClose}
          />
        )}
      </div>
    </>
  )
}

function Content(props) {
  const { children, size, ...rest } = props

  const maxWidth = modalContentSizes[size] || "100%"

  return (
    <div className={styles.modalContent} style={{ maxWidth }} {...rest}>
      {children}
    </div>
  )
}

function Footer(props) {
  const { children, size, style, ...rest } = props

  const maxWidth = modalContentSizes[size] || "100%"

  return (
    <div className={styles.modalFooter} style={{ ...style, maxWidth }} {...rest}>
      {children}
    </div>
  )
}

function MainModal(props) {
  const {
    children,
    size = "md",
    nOverlayZindex = 4,
    translateX = "-50%",
    positionLeft = "50%",
    maxHeight = "calc(100% - 150px)",
    height = "auto",
    isDrawer = false,
    closeOnClickOutside = false,
    customWidth,
    className,
    ...rest
  } = props

  const maxWidth = customWidth ? customWidth : modalSizes[size] || modalSizes.md
  const customStyles = {
    overlay: {
      background: "rgba(0, 0, 0, 0.4)",
      zIndex: nOverlayZindex,
    },
    content: {
      maxWidth,
      width: "100%",
      minHeight: "100%",
      padding: 0,
      border: "none",
      overflow: "hidden",
      top: "50.1%",
      right: positionLeft === "100%" ? "0" : "50%",
      left: `${positionLeft}`,
      transform: `translate3d(${translateX}, -50%, 2px)`,
      background: "transparent",
    },
  }

  const elHeader = React.Children.toArray(children)?.find(
    (c) => c?.type?.name === "Header",
  )
  const elChildrens = React.Children.toArray(children)?.filter(
    (c) => c?.type?.name !== "Header",
  )

  return (
    <ReactModal
      style={customStyles}
      shouldCloseOnOverlayClick={closeOnClickOutside}
      shouldCloseOnEsc={false}
      {...rest}
    >
      <div
        className={`${styles.modalContainer} ${className || ''}`}
        style={{
          maxHeight: maxHeight,
          height: height,
          minHeight: isDrawer ? "auto" : "250px",
        }}
      >
        {elHeader}
        <div id="modalOverflowContentContainer" className={styles.modalOverflowContent}>
          <div id="modal-overflow-content" className={styles.modalOverflowContent}>
            {React.Children.map(elChildrens, (elChildren) =>
              React.cloneElement(elChildren, { props, size }),
            )}
          </div>
        </div>
      </div>
    </ReactModal>
  )
}

const Modal = Object.assign(MainModal, { Header, Content, Footer })

export default Modal
